<div class="">
  <div class="maindiv">
    <div class="headerLogo">
      <div class="rectangle-copy">
        <img src="assets/se-logow.svg" width="163px" height="34px" alt="SE Logo" class="selogo">
      </div>
      <div>
        <img width="960px" height="150px" src="assets/Bitmap.png" alt="">
      </div>
    </div>
    <div class="scroll">
      <div class="topdiv">
        <p>Eliwell AIR T&C</p>
        <div class="div1">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" rel="noopener noreferrer" href="assets/TelevisAirT&C/TelevisAirT&C_EN.pdf" target="_blank">
              Eliwell AIR Terms&Cond_EN
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" rel="noopener noreferrer" href="assets/TelevisAirT&C/TelevisAirT&C_ES.pdf" target="_blank">
              Eliwell AIR Terms&Cond_ES
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" rel="noopener noreferrer" href="assets/TelevisAirT&C/TelevisAirT&C_IT.pdf" target="_blank">
              Eliwell AIR Terms&Cond_IT
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor CS_Doc" rel="noopener noreferrer" href="assets/TelevisAirT&C/Recommended_Cybersecurity_Best_Practices.pdf" target="_blank">Cyber Security Best Practices</a>
          </div>
        </div>
        <div class="div2">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" rel="noopener noreferrer" href="assets/TelevisAirT&C/TelevisAirT&C_DE.pdf" target="_blank">
              Eliwell AIR Terms&Cond_DE
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" rel="noopener noreferrer" href="assets/TelevisAirT&C/TelevisAirT&C_FR.pdf" target="_blank">
              Eliwell AIR Terms&Cond_FR
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" rel="noopener noreferrer" href="assets/TelevisAirT&C/TelevisAirT&C_RU.pdf" target="_blank">
              Eliwell AIR Terms&Cond_RU
            </a>
          </div>
        </div>
      </div>
      <div class="topdiv mt260px">
        <p>Eliwell AIR Service description</p>
        <div class="div1">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/TelevisAir Service description/E_AIR_04EN MAN Eliwell AIR Silent Guardian EN 0926.pdf"
               rel="noopener noreferrer" target="_blank">Eliwell AIR User Guide</a>
          </div>
        </div>
      </div>
      <div class="topdiv mt80px">
        <p>Mobile APP Terms of Use</p>
        <div class="div1">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP Terms of Use/Eliwell Air TermsOfUse_EN.pdf"
               rel="noopener noreferrer" target="_blank">Eliwell AIR TermsOfUse_EN</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP Terms of Use/Eliwell Air TermsOfUse_ES.pdf"
               rel="noopener noreferrer" target="_blank">Eliwell AIR TermsOfUse_ES</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP Terms of Use/Eliwell Air TermsOfUse_IT.pdf"
               rel="noopener noreferrer" target="_blank">Eliwell AIR TermsOfUse_IT</a>
          </div>
        </div>
        <div class="div2">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP Terms of Use/Eliwell Air TermsOfUse_DE.pdf"
               rel="noopener noreferrer" target="_blank">Eliwell AIR TermsOfUse_DE</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP Terms of Use/Eliwell Air TermsOfUse_FR.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR TermsOfUse_FR</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP Terms of Use/Eliwell Air TermsOfUse_RU.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR TermsOfUse_RU</a>
          </div>
        </div>
      </div>
      <div class="topdiv mt210px">
        <p>Mobile APP description</p>
        <div class="div1">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP description/Eliwell Air User Guide_EN.pdf" rel="noopener noreferrer" target="_blank">
              Eliwell AIR User Guide_EN
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP description/Eliwell Air User Guide_ES.pdf" rel="noopener noreferrer" target="_blank">
              Eliwell AIR User Guide_ES
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP description/Eliwell Air User Guide_IT.pdf" rel="noopener noreferrer" target="_blank">
              Eliwell AIR User Guide_IT
            </a>
          </div>
        </div>
        <div class="div2">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP description/Eliwell Air User Guide_DE.pdf" rel="noopener noreferrer" target="_blank">
              Eliwell AIR User Guide_DE
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP description/Eliwell Air User Guide_FR.pdf" rel="noopener noreferrer" target="_blank">
              Eliwell AIR User Guide_FR
            </a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Mobile APP description/Eliwell Air User Guide_RU.pdf" rel="noopener noreferrer" target="_blank">
              Eliwell AIR User Guide_RU
            </a>
          </div>
        </div>
      </div>

      <div class="topdiv mt210px">
        <p>Privacy Policy</p>
        <div class="div1">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Privacy Policy/TelevisAir Privacy Notice_EN.pdf"
               rel="noopener noreferrer" target="_blank">Eliwell AIR Privacy Notice_EN</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Privacy Policy/TelevisAir Privacy Notice_ES.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR Privacy Notice_ES</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Privacy Policy/TelevisAir Privacy Notice_IT.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR Privacy Notice_IT</a>
          </div>
        </div>
        <div class="div2">
          <div class="rectangle">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Privacy Policy/TelevisAir Privacy Notice_DE.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR Privacy Notice_DE</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Privacy Policy/TelevisAir Privacy Notice_FR.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR Privacy Notice_FR</a>
          </div>
          <div class="rectangle mt10">
            <img height="31px" width="24px" src="assets/ic-pdf.png" alt="" class="ml10">
            <a class="anchor" href="assets/Privacy Policy/TelevisAir Privacy Notice_RU.pdf" rel="noopener noreferrer"
               target="_blank">Eliwell AIR Privacy Notice_RU</a>
          </div>
        </div>
      </div>

      <div class="topdiv mt210px">
        <p>Eliwell sales condition</p>
        <div class="div1">
          <a class="anchorempty" rel="noopener noreferrer" href='{{environment_termsOfPurchaseUrl}}'
             target="_blank">Eliwell Sales Conditions</a>
        </div>

      </div>

    </div>
    <div class="rect-bottom">
      <img src="assets/eliwell.svg" width="155px" height="38px" alt="" class="eliwellLogo">
    </div>
  </div>
</div>
